package com.exura.features.firebase.domain.model.versioning

import com.exura.features.firebase.domain.model.SerializableDomainModel
import com.exura.features.firebase.domain.repository.SerializableDomainModelRepository
import dev.gitlive.firebase.firestore.CollectionReference
import kotlinx.datetime.LocalDateTime

data class Version<T: SerializableDomainModel, M: VersionMetadata>(
    override val firebaseDocPrefix: CollectionReference? = null,
    override val firebaseDocId: String? = null,

    val rootVersionId: String,
    val parentVersionId: String?,
    val isActive: Boolean,

    val metadata: M? = null,

    val contentDocPrefix: CollectionReference,
    val createdAt: LocalDateTime,
) : SerializableDomainModel {

    private var _content: T? = null

    suspend fun getContent(): T = getContent(null)

    /**
     * Retrieves the actual content. Loads it if not already loaded.
     */
    suspend fun getContent(repository: SerializableDomainModelRepository<T>? = null): T {
        val fromRepo: suspend () -> Result<T> = {
            val repo = repository ?: throw IllegalArgumentException("Can't get content without specifying repo.")
            val docId = firebaseDocId ?: throw IllegalArgumentException("Can't get content for unspecified document.")
            repo.read(contentDocPrefix.document(docId))
        }
        return _content ?: fromRepo().getOrThrow().also { _content = it }
    }

    fun setLocalContent(newContent: T) {
        if(_content != null) {
            throw IllegalStateException("Can't set content on non-empty version")
        }
        _content = newContent
    }
}
